export default {
  metrics: {
    go_lives: 'Total des lancements',
    avg_quality_score: 'Score qualité moyen',
    managers: {
      title: 'Responsables onboarding',
      fields: {
        name: 'Nom du responsable',
        go_lives: 'Lancements',
        avg_quality_score: 'Score qualité moy.',
      },
    },
  },
  details: {
    name: 'Restaurant',
    owner: 'Nom du propriétaire',
    owner_phone: 'Téléphone du propriétaire',
    owner_email: 'E-mail du propriétaire',
    live_from: 'Date de lancement',
    onboarding_manager: 'Responsable onboarding',
    sales_manager: 'Responsable commercial',
    onboarding_quality_score: 'Score qualité',
    export_csv: 'Exporter CSV',
  },
};
